"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
exports.data = [
    {
        country: constants_1.Country.NL,
        id: 1,
        pattern: '(\\d{4})(\\s?)(\\w{2})',
        subcoId: 1,
    },
];
